<div class="modal-header-custom d-flex flex-row">
    <mat-icon (click)="close()" class="close">close</mat-icon>
</div>
<div class="modal-title d-flex flex-row">
    <i><mat-icon>language</mat-icon></i>
    <h2> {{ 'HEADER.CHANGE_LANGUAGE' | translate }}</h2>
</div>

<mat-dialog-content>
    <mat-horizontal-stepper #stepper>
        <mat-step>
            <div class="row mb-1">
                <div class="col-12">
                    <div>
                        <mat-selection-list #shoes [multiple]="false">
                            <mat-list-option *ngFor="let language of languages" (click)="onAreaListControlChanged(language)" [value]="language.translateValue">
                              <button class="mat-raised-button">{{language.name | translate}}</button>
                            </mat-list-option>
                          </mat-selection-list>
                    </div>                     
                </div>
            </div>
        </mat-step> 
    </mat-horizontal-stepper>
</mat-dialog-content>
